<template>
	<div class="pronto-progress" :class="{ square }" :data-percent="percent">
		<div class="pronto-progress-bar" />
	</div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
	percent: { type: Number, default: 0 },
	size: { type: [Number, String], default: '4px' },
	square: { type: Boolean, default: false },
	transitionDelay: { type: Number, default: 0.5 },
})
const sizePx = computed(() =>
	Number.isInteger(props.size) ? `${props.size}px` : props.size
)
const delay = computed(() =>
	Number.isFinite(props.transitionDelay) ? `${props.transitionDelay}s` : '0s'
)
</script>

<style lang="scss" scoped>
.pronto-progress {
	height: v-bind(sizePx);
	background-color: var(--neutral-300);
	border-radius: calc(v-bind(sizePx) / 2);
	width: 100%;
	overflow: hidden;
	&.square {
		border-radius: 0;
	}
	.pronto-progress-bar {
		height: 100%;
		// convert percent integer into css percentage units
		width: calc(v-bind(percent) / 100 * 100%);
		transition: width ease-in-out v-bind(delay);
		background-color: var(--teal-300);
	}
}
</style>
